import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  connect() {
    this.initializeDataTable()
  }

  initializeDataTable() {
    $(this.tableTarget).DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: '/admin/waitlist_entries.json',
        type: 'POST'
      },
      columns: [
        { data: 'name' },
        { data: 'title' },
        { data: 'type' },
        { data: 'user' },
        { data: 'email' },
        { data: 'created_at' },
        { data: 'invitation_expires_at' },
        { 
          data: 'status',
          render: function(data) {
            return statusPillHtml(data);
          }
        },
        { data: 'waitlisted_on' },
        { 
          data: null,
          render: function(data) {
            return actionButtonsHtml(data);
          }
        }
      ],
      order: [[ 7, 'asc' ]],  // Sort by status column by default
      columnDefs: [{
        targets: 7,  // Status column
        orderData: [7],  // Use the status column for sorting
        createdCell: function (td, cellData) {
          $(td).attr('data-order', getStatusOrder(cellData));
        }
      }],
      responsive: true,
      orderCellsTop: true
    });
  }
}
